import React from "react";

function DataDrivenSvg({ color = "#000000", width = 24, height = 24 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width={width}
      height={height}
      x="0"
      y="0"
      viewBox="0 0 512 512"
      fill={color}
    >
      <g>
        <g data-name="04-data driven">
          <path
            d="M56 356a12 12 0 0 0-12 12v104h72V368a12 12 0 0 0-12-12zM176 324a12 12 0 0 0-12 12v136h72V336a12 12 0 0 0-12-12zM296 260a12 12 0 0 0-12 12v200h72V272a12 12 0 0 0-12-12zM416 164a12 12 0 0 0-12 12v296h72V176a12 12 0 0 0-12-12zM496 484H16a12 12 0 0 0 0 24h480a12 12 0 0 0 0-24zM44 304a12 12 0 0 0 12 12c63.616 0 158.172-37.586 246.768-98.09 43.174-29.486 81.522-62.293 110.9-94.875 20.43-22.662 36.2-44.717 47.177-65.938l7.441 33.503c3.876 15.419 26.478 10.267 23.428-5.206l-16-72a12.1 12.1 0 0 0-15.928-8.633l-64 24a12 12 0 0 0 8.428 22.472l40.007-15C421.534 87.134 365.6 145.94 289.232 198.09 205.7 255.138 114.148 292 56 292a12 12 0 0 0-12 12z"
            fill={color}
            opacity="1"
            data-original={color}
          ></path>
          <path
            d="m18.13 148.314 16.237 2 5.42 13.028-10.044 12.824a6 6 0 0 0 .49 7.951l28.832 28.706a6 6 0 0 0 7.914.488l12.906-10.02 13.124 5.409 2.006 16.143a6 6 0 0 0 5.954 5.26h40.774a6 6 0 0 0 5.954-5.259L149.7 208.7l13.124-5.412 12.906 10.02a6 6 0 0 0 7.913-.488l28.832-28.706a6 6 0 0 0 .491-7.951l-10.044-12.824 5.42-13.028 16.237-2a6 6 0 0 0 5.267-5.955v-40.6a6 6 0 0 0-5.267-5.955l-16.237-2-5.42-13.027 10.048-12.817a6 6 0 0 0-.491-7.952L183.647 31.3a6 6 0 0 0-7.913-.487l-12.906 10.02-13.128-5.414-2-16.144a6 6 0 0 0-5.954-5.26h-40.777a6 6 0 0 0-5.954 5.26l-2.006 16.144-13.124 5.413-12.906-10.02a6 6 0 0 0-7.914.487L30.233 60.005a6 6 0 0 0-.49 7.952L39.787 80.78l-5.42 13.027-16.237 2a6 6 0 0 0-5.267 5.955v40.6a6 6 0 0 0 5.267 5.952zM99.459 100.3a30.94 30.94 0 0 1 21.9-9.016c16.178-.508 31.456 14.219 30.955 30.781a30.511 30.511 0 0 1-9.057 21.765 31.1 31.1 0 0 1-43.795 0 30.68 30.68 0 0 1 0-43.53z"
            fill={color}
            opacity="1"
            data-original={color}
          ></path>
        </g>
      </g>
    </svg>
  );
}

export default DataDrivenSvg;
